import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button } from '../../Button';
import { Input } from '../../Input';
import Select from '../../Select';
import { Textarea } from '../../Textarea';
import { useCreateGalleryModalController } from './useCreateGalleryModalController';

interface ICreateGalleryModalProps {
  leadId: string;
}

export default function CreateGalleryModal({
  leadId,
}: ICreateGalleryModalProps) {
  const { t } = useTranslation();
  const {
    register,
    control,
    errors,
    eventOptions,
    onSubmit,
    createGalleryIsPending,
    handleCloseModal,
  } = useCreateGalleryModalController({ leadId });

  return (
    <form
      className="my-4 flex w-full flex-col gap-4"
      onSubmit={onSubmit}
      noValidate
    >
      <Input
        type="text"
        placeholder={t('gallery.createModal.fields.name')}
        {...register('name')}
        error={errors.name?.message}
        disabled={createGalleryIsPending}
      />

      {eventOptions.length > 0 && (
        <Controller
          control={control}
          name="eventId"
          render={({ field: { value, onChange } }) => (
            <Select
              placeholder={t('gallery.createModal.fields.event')}
              options={eventOptions}
              value={value}
              emptyOption
              emptyOptionLabel={t('gallery.createModal.fields.noEvent')}
              onChange={onChange}
            />
          )}
        />
      )}

      <Input
        type="number"
        inputMode="numeric"
        min={1}
        placeholder={t('gallery.createModal.fields.selectionLimit')}
        {...register('selectionLimit')}
        error={errors.selectionLimit?.message}
        disabled={createGalleryIsPending}
      />

      <Textarea
        placeholder={t('gallery.createModal.fields.clientMessage')}
        {...register('clientMessage')}
        error={errors.clientMessage?.message}
        disabled={createGalleryIsPending}
      />

      <div className="flex w-full gap-3">
        <Button
          className="h-10 flex-1 text-sm"
          color="ghost"
          onClick={handleCloseModal}
          disabled={createGalleryIsPending}
        >
          {t('gallery.createModal.cancel')}
        </Button>
        <Button
          className="h-10 flex-1 text-sm"
          color="primary"
          type="submit"
          isLoading={createGalleryIsPending}
        >
          {t('gallery.createModal.submit')}
        </Button>
      </div>
    </form>
  );
}
